import { Controller } from "@hotwired/stimulus"

// Filters items on the page by typing in an input.
// Add data-local-search-target="input" to the input
// and data-local-search-target="item" to each card you want to filter.
// Optional: set data-search on an item to override the text being searched.
export default class extends Controller {
    static targets = ["input", "item"]

    connect() {
        this._timer = null
    }

    filter() {
        // tiny debounce so it feels smooth
        clearTimeout(this._timer)
        this._timer = setTimeout(() => {
            const q = this.inputTarget.value.trim().toLowerCase()

            this.itemTargets.forEach((el) => {
                const haystack = (el.dataset.search || el.textContent || "").toLowerCase()
                el.classList.toggle("d-none", q && !haystack.includes(q))
            })
        }, 50)
    }
}